import type { IAddressSource } from "@/domains/manager/interfaces"
import type { IWalletConnectionStore } from "@/domains/wallet/types"

/**
 * Address source that only uses the connected wallet address.
 * Used by the main Lock orchestrator.
 */
export class WalletAddressSource implements IAddressSource {
  constructor(private readonly walletStore: IWalletConnectionStore) {}

  getCurrentAddress() {
    return this.walletStore.connectedAddress ?? null
  }
}
